import "core-js/modules/es.array.for-each";
import "core-js/modules/es.function.name";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.string.replace";
import "core-js/modules/web.dom-collections.for-each";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/drone_race_manage/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import addDivisionCore from './component/addDivisionCore.vue';
import { pageSize } from '@/mixins/index';
export default {
  name: "divisionCoreManage",
  components: {
    addDivisionCore: addDivisionCore
  },
  mixins: [pageSize],
  data: function data() {
    return {
      paramsData: {
        page: 1,
        page_size: 10
      },
      tableData: [],
      total: 0,
      value2: [],
      divisionAllList: [],
      statusList: [{
        label: '未开始',
        value: 0
      }, {
        label: '进行中',
        value: 1
      }, {
        label: '已结束待结算',
        value: 2
      }, {
        label: '已结算',
        value: 3
      }]
    };
  },
  created: function created() {
    this.getDivisionList();
    this.getList();
  },
  destroyed: function destroyed() {
    sessionStorage.removeItem('eventId');
    sessionStorage.removeItem('rewardGroupID');
    sessionStorage.removeItem('endTime');
  },
  methods: {
    getDivisionList: function getDivisionList() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.$api.divisionList({
                  page_size: -1
                }).then(function (res) {
                  if (res.code == 200) {
                    var data = res.data;
                    _this.divisionAllList = data;
                  }
                });

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    isBeforeEndTime: function isBeforeEndTime(endTime) {
      if (!endTime) return false;
      var now = new Date();
      var end = new Date(endTime.replace(/-/g, '/'));
      return now < end;
    },
    datechange: function datechange() {
      if (this.value2 && this.value2.length > 0) {
        this.paramsData.start_time = this.value2[0];
        this.paramsData.end_time = this.value2[1];
      } else {
        this.paramsData.start_time = '';
        this.paramsData.end_time = '';
      }
    },
    getList: function getList() {
      var _arguments = arguments,
          _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var page;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                page = _arguments.length > 0 && _arguments[0] !== undefined ? _arguments[0] : 1;
                _this2.paramsData.page = page;

                _this2.$api.eventList(_this2.paramsData).then(function (res) {
                  if (res.code == 200) {
                    var data = res.data.data;
                    data.forEach(function (item) {
                      item.division_name = item.division.name ? item.division.name : '';
                      item.reward_name = item.reward_group.name ? item.reward_group.name : '';
                    });
                    _this2.tableData = data;
                    _this2.total = res.data.total;
                  }
                });

              case 3:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    handleMange: function handleMange(row) {
      sessionStorage.setItem('eventId', row.id);
      sessionStorage.setItem('rewardGroupID', row.reward_group.id);
      sessionStorage.setItem('endTime', row.end_time);
      sessionStorage.setItem('eventStatus', row.status);
      this.$router.push({
        path: "/divisionManage/divisionAllController",
        query: {
          eventId: row.id,
          eventStatus: row.status
        }
      });
    },
    handleDelete: function handleDelete(id) {
      var _this3 = this;

      this.$confirm("此操作将删除该赛事, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this3.$api.eventDelete({
                  id: id
                }).then(function (res) {
                  if (res.code == 200) {
                    _this3.$message.success("删除成功!");

                    _this3.getList(_this3.paramsData.page);
                  } else {
                    _this3.$message.error(res.msg);
                  }
                });

              case 1:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      })));
    },
    advanceOver: function advanceOver(id) {
      var _this4 = this;

      this.$confirm("此操作将提前手动结束赛事, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _this4.$api.eventEnd({
                  id: id
                }).then(function (res) {
                  if (res.code == 200) {
                    _this4.$message.success("提前结束成功!");

                    _this4.getList(_this4.paramsData.page);
                  } else {
                    _this4.$message.error(res.msg);
                  }
                });

              case 1:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      })));
    }
  }
};